export const ProductsIcs = [
    {
        CD_PRODUTO: 2136,
        NM_PRODUTO: "Ituran com Seguro Roubo e Furto",
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
                CD_PRODUTO_ADD: 4
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            }
        ],
        DS_TOOLTIP: 'Cobertura base para todos os produtos Ituran com Seguro. Garante a indenização em casos do veículo roubado/furtado que não haja a recuperação.'
    },
    {
        CD_PRODUTO: 2463,
        NM_PRODUTO: "Ituran com Seguro Roubo e Furto",
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
                CD_PRODUTO_ADD: 4
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            }
        ],
        DS_TOOLTIP: 'Cobertura base para todos os produtos Ituran com Seguro. Garante a indenização em casos do veículo roubado/furtado que não haja a recuperação.'
    },
    {
        CD_PRODUTO: 2140,
        NM_PRODUTO: 'Ituran com Seguro + Terceiros',
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
                CD_PRODUTO_ADD: 6
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
                CD_PRODUTO_ADD: 4
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            }
        ],
        DS_TOOLTIP: 'Roubo e Furto + a cobertura de Seguro de Responsabilidade Civil Facultativa de Veículos (RCF-V ou terceiros).'
    },
    {
        CD_PRODUTO: 2141,
        NM_PRODUTO: 'Ituran com Seguro + Perda Total',
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Perda Total por Colisão',
                CD_PRODUTO_ADD: 9
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Perda Total por Alagamento',
                CD_PRODUTO_ADD: 10
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
                CD_PRODUTO_ADD: 4
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            }
        ],
        DS_TOOLTIP: ''
    },
    {
        CD_PRODUTO: 2426,
        NM_PRODUTO: 'Ituran com Seguro + Colisão',
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Perda Total por Colisão',
                CD_PRODUTO_ADD: 9
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Perda Total por Alagamento',
                CD_PRODUTO_ADD: 10
            },
            {
                NM_PRODUTO_ADD: 'Cobertura de Perda Parcial (Franquia Normal)',
                CD_PRODUTO_ADD: 11
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
                CD_PRODUTO_ADD: 4
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            }
        ],
        DS_TOOLTIP: 'Roubo e Furto + a cobertura de Perda Total por alagamento, colisão, abalroamento ou capotagem acidental.'
    },
    {
        CD_PRODUTO: 2143,
        NM_PRODUTO: 'Ituran com Seguro Combo',
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Perda Total por Colisão',
                CD_PRODUTO_ADD: 9
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Perda Total por Alagamento',
                CD_PRODUTO_ADD: 10
            },
            {
                NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
                CD_PRODUTO_ADD: 6
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
                CD_PRODUTO_ADD: 4
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            }
        ],
        DS_TOOLTIP: 'Contempla os produtos Roubo e Furto + Terceiros + Perda Total Colisão.'
    },
    {
        CD_PRODUTO: 2427,
        NM_PRODUTO: 'Ituran com Seguro Completo',
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Perda Total por Colisão',
                CD_PRODUTO_ADD: 9
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Perda Total por Alagamento',
                CD_PRODUTO_ADD: 10
            },
            {
                NM_PRODUTO_ADD: 'Cobertura de Perda Parcial (Franquia Normal)',
                CD_PRODUTO_ADD: 11
            },
            {
                NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
                CD_PRODUTO_ADD: 6
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
                CD_PRODUTO_ADD: 4
            },
            {
                NM_PRODUTO_ADD: 'Carro Reserva',
                CD_PRODUTO_ADD: 12
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            }
        ],
        DS_TOOLTIP: 'Contempla os produtos Roubo e Furto + Terceiros + Perda Total Colisão + a cobertura de Perda Parcial para danos ao veículo segurado + Carro Reserva.'
    },
    {
        CD_PRODUTO: 7328,
        NM_PRODUTO: 'Ituran com Seguro Premium',
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Perda Total por Colisão',
                CD_PRODUTO_ADD: 9
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Perda Total por Alagamento',
                CD_PRODUTO_ADD: 10
            },
            {
                NM_PRODUTO_ADD: 'Cobertura de Perda Parcial (Franquia Reduzida)',
                CD_PRODUTO_ADD: 14,
            },
            {
                NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
                CD_PRODUTO_ADD: 6
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
                CD_PRODUTO_ADD: 4
            },
            {
                NM_PRODUTO_ADD: 'Carro Reserva',
                CD_PRODUTO_ADD: 12
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            }
        ],
        DS_TOOLTIP: 'Contempla os produtos Roubo e Furto + Terceiros + Perda Total Colisão + a cobertura de Perda Parcial para danos ao veículo segurado + Carro Reserva.'
    },
    {
        CD_PRODUTO: 7329,
        NM_PRODUTO: 'Ituran com Seguro Premium',
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Perda Total por Colisão',
                CD_PRODUTO_ADD: 9
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Perda Total por Alagamento',
                CD_PRODUTO_ADD: 10
            },
            {
                NM_PRODUTO_ADD: 'Cobertura de Perda Parcial (Franquia Reduzida)',
                CD_PRODUTO_ADD: 14
            },
            {
                NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
                CD_PRODUTO_ADD: 6
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
                CD_PRODUTO_ADD: 4
            },
            {
                NM_PRODUTO_ADD: 'Carro Reserva',
                CD_PRODUTO_ADD: 12
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            }
        ],
        DS_TOOLTIP: 'Contempla os produtos Roubo e Furto + Terceiros + Perda Total Colisão + a cobertura de Perda Parcial para danos ao veículo segurado + Carro Reserva.'
    },
    {
        CD_PRODUTO: 2434,
        NM_PRODUTO: 'Ituran com Seguro Roubo e Furto Moto',
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Indenização tabela FIPE',
                CD_PRODUTO_ADD: 2
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
                CD_PRODUTO_ADD: 4
            }
        ],
        DS_TOOLTIP: ''
    },
    {
        CD_PRODUTO: 2435,
        NM_PRODUTO: 'Ituran com Seguro Moto + Terceiros',
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Indenização tabela FIPE',
                CD_PRODUTO_ADD: 2
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
                CD_PRODUTO_ADD: 4
            },
            {
                NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
                CD_PRODUTO_ADD: 5
            },
        ],
        DS_TOOLTIP: ''
    },
    {
        CD_PRODUTO: 2692,
        NM_PRODUTO: 'Ituran com Seguro EV Roubo e Furto',
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
                CD_PRODUTO_ADD: 4
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
        ],
        DS_TOOLTIP: 'Esta é a cobertura base para todos os produtos Ituran com Seguro EV – produto exclusivo para veículos elétricos e híbridos. Garante a indenização de veículo roubado/furtado que não haja a recuperação.'
    },
    {
        CD_PRODUTO: 2694,
        NM_PRODUTO: 'Ituran com Seguro EV + Terceiros',
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
                CD_PRODUTO_ADD: 6
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
                CD_PRODUTO_ADD: 4
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
        ],
        DS_TOOLTIP: 'Roubo e Furto + a cobertura de Seguro de Responsabilidade Civil Facultativa de Veículos (RCF-V ou terceiros).'
    },
    {
        CD_PRODUTO: 2693,
        NM_PRODUTO: 'Ituran com Seguro EV + Perda Total Colisão',
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Perda Total por Colisão',
                CD_PRODUTO_ADD: 9
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Perda Total por Alagamento',
                CD_PRODUTO_ADD: 10
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
                CD_PRODUTO_ADD: 4
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
        ],
        DS_TOOLTIP: 'Ituran com Seguro Roubo e Furto + a cobertura de Perda Total por alagamento, colisão, abalroamento ou capotagem acidental.'
    },
    {
        CD_PRODUTO: 2695,
        NM_PRODUTO: 'Ituran com Seguro EV Combo',
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Perda Total por Colisão',
                CD_PRODUTO_ADD: 9
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Perda Total por Alagamento',
                CD_PRODUTO_ADD: 10
            },
            {
                NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
                CD_PRODUTO_ADD: 6
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
                CD_PRODUTO_ADD: 4
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
        ],
        DS_TOOLTIP: 'Contempla os produtos Roubo e Furto + Terceiros + Perda Total Colisão.'
    },
    {
        CD_PRODUTO: 2696,
        NM_PRODUTO: 'Ituran com Seguro EV Completo',
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Carro Reserva',
                CD_PRODUTO_ADD: 12
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Perda Total por Colisão',
                CD_PRODUTO_ADD: 9
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Perda Total por Alagamento',
                CD_PRODUTO_ADD: 10
            },
            {
                NM_PRODUTO_ADD: 'Cobertura de Perda Parcial (Franquia Normal)',
                CD_PRODUTO_ADD: 11
            },
            {
                NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
                CD_PRODUTO_ADD: 6
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
                CD_PRODUTO_ADD: 4
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
        ],
        DS_TOOLTIP: 'Contempla os produtos Roubo e Furto + Terceiros + Perda Total Colisão + a cobertura de Perda Parcial para danos ao veículo segurado + Carro Reserva.'
    },
    {
        CD_PRODUTO: 7330,
        NM_PRODUTO: 'Ituran com Seguro EV Premium',
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Perda Total por Colisão',
                CD_PRODUTO_ADD: 9
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Perda Total por Alagamento',
                CD_PRODUTO_ADD: 10
            },
            {
                NM_PRODUTO_ADD: 'Cobertura de Perda Parcial (Franquia Reduzida)',
                CD_PRODUTO_ADD: 14,
            },
            {
                NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
                CD_PRODUTO_ADD: 6
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
                CD_PRODUTO_ADD: 4
            },
            {
                NM_PRODUTO_ADD: 'Carro Reserva',
                CD_PRODUTO_ADD: 12
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            }
        ],
        DS_TOOLTIP: 'Contempla os produtos Roubo e Furto + Terceiros + Perda Total Colisão + a cobertura de Perda Parcial para danos ao veículo segurado + Carro Reserva. Carbonus - Desconto de até R$1.500 ao ano, na sua fatura. *Somente para carros elétricos elegíveis. Consulte condições em info.ituran.com.br/carbonus-ev.'
    },
    {
        CD_PRODUTO: 2803,
        NM_PRODUTO: "Ituran com Seguro Light 75 Roubo e Furto",
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3,
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 15,
            }
        ],
        DS_TOOLTIP: 'Cobertura base para todos os produtos Ituran com Seguro Light. Garante a indenização em casos do veículo roubado/furtado que não haja a recuperação.'
    },
    {
        CD_PRODUTO: 2804,
        NM_PRODUTO: 'Ituran com Seguro Light 75 + Terceiros',
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3,
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 15,
            },
            {
                NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
                CD_PRODUTO_ADD: 6
            }
        ],
        DS_TOOLTIP: 'Roubo e Furto + a cobertura de Seguro de Responsabilidade Civil Facultativa de Veículos (RCF-V ou terceiros).'
    },
    {
        CD_PRODUTO: 2805,
        NM_PRODUTO: "Ituran com Seguro Light 90 Roubo e Furto",
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3,
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 15,
            }
        ],
        DS_TOOLTIP: 'Cobertura base para todos os produtos Ituran com Seguro Light. Garante a indenização em casos do veículo roubado/furtado que não haja a recuperação.'
    },
    {
        CD_PRODUTO: 2806,
        NM_PRODUTO: 'Ituran com Seguro Light 90 + Terceiros',
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3,
            },
            {
                NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
                CD_PRODUTO_ADD: 6
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 15,
            }
        ],
        DS_TOOLTIP: 'Roubo e Furto + a cobertura de Seguro de Responsabilidade Civil Facultativa de Veículos (RCF-V ou terceiros).'
    },
    {
        CD_PRODUTO: 2882,
        NM_PRODUTO: "Ituran com Seguro Light 75 Roubo e Furto",
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3,
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 15,
            }
        ],
        DS_TOOLTIP: 'Cobertura base para todos os produtos Ituran com Seguro Light. Garante a indenização em casos do veículo roubado/furtado que não haja a recuperação.'
    },
    {
        CD_PRODUTO: 2883,
        NM_PRODUTO: "Ituran com Seguro Light 75 + Terceiros",
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3,
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 15,
            },
            {
                NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
                CD_PRODUTO_ADD: 6
            },
        ],
        DS_TOOLTIP: 'Roubo e Furto + a cobertura de Seguro de Responsabilidade Civil Facultativa de Veículos (RCF-V ou terceiros).'
    },
    {
        CD_PRODUTO: 2884,
        NM_PRODUTO: "Ituran com Seguro Light 90 Roubo e Furto",
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3,
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 15,
            }
        ],
        DS_TOOLTIP: 'Cobertura base para todos os produtos Ituran com Seguro Light. Garante a indenização em casos do veículo roubado/furtado que não haja a recuperação.'
    },
    {
        CD_PRODUTO: 2885,
        NM_PRODUTO: "Ituran com Seguro Light 90 + Terceiros",
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3,
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 15,
            },
            {
                NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
                CD_PRODUTO_ADD: 6
            },
        ],
        DS_TOOLTIP: 'Roubo e Furto + a cobertura de Seguro de Responsabilidade Civil Facultativa de Veículos (RCF-V ou terceiros).'
    },
    {
        CD_PRODUTO: 2874,
        NM_PRODUTO: "Ituran com Seguro Light 75 Roubo e Furto Moto",
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3,
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 15,
            }
        ],
        DS_TOOLTIP: 'Cobertura base para todos os produtos Ituran com Seguro Light. Garante a indenização em casos do veículo roubado/furtado que não haja a recuperação.'
    },
    {
        CD_PRODUTO: 2875,
        NM_PRODUTO: "Ituran com Seguro Light 75 + Terceiros",
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3,
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 15,
            },
            {
                NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
                CD_PRODUTO_ADD: 6
            },
        ],
        DS_TOOLTIP: 'Roubo e Furto + a cobertura de Seguro de Responsabilidade Civil Facultativa de Veículos (RCF-V ou terceiros).'
    },
    {
        CD_PRODUTO: 2876,
        NM_PRODUTO: "Ituran com Seguro Light 90 Roubo e Furto Moto",
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3,
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 15,
            }
        ],
        DS_TOOLTIP: 'Cobertura base para todos os produtos Ituran com Seguro Light. Garante a indenização em casos do veículo roubado/furtado que não haja a recuperação.'
    },
    {
        CD_PRODUTO: 2877,
        NM_PRODUTO: "Ituran com Seguro Light 90 + Terceiros",
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3,
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 15,
            },
            {
                NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
                CD_PRODUTO_ADD: 6
            },
        ],
        DS_TOOLTIP: 'Roubo e Furto + a cobertura de Seguro de Responsabilidade Civil Facultativa de Veículos (RCF-V ou terceiros).'
    },
    {
        CD_PRODUTO: 2878,
        NM_PRODUTO: "Ituran com Seguro Light 75 Roubo e Furto Moto",
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3,
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 15,
            }
        ],
        DS_TOOLTIP: 'Cobertura base para todos os produtos Ituran com Seguro Light. Garante a indenização em casos do veículo roubado/furtado que não haja a recuperação.'
    },
    {
        CD_PRODUTO: 2879,
        NM_PRODUTO: "Ituran com Seguro Light 75 + Terceiros",
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3,
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 15,
            },
            {
                NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
                CD_PRODUTO_ADD: 6
            },
        ],
        DS_TOOLTIP: 'Roubo e Furto + a cobertura de Seguro de Responsabilidade Civil Facultativa de Veículos (RCF-V ou terceiros).'
    },
    {
        CD_PRODUTO: 2880,
        NM_PRODUTO: "Ituran com Seguro Light 90 Roubo e Furto Moto",
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3,
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 15,
            }
        ],
        DS_TOOLTIP: 'Cobertura base para todos os produtos Ituran com Seguro Light. Garante a indenização em casos do veículo roubado/furtado que não haja a recuperação.'
    },
    {
        CD_PRODUTO: 2881,
        NM_PRODUTO: "Ituran com Seguro Light 90 + Terceiros",
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3,
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 15,
            },
            {
                NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
                CD_PRODUTO_ADD: 6
            },
        ],
        DS_TOOLTIP: 'Roubo e Furto + a cobertura de Seguro de Responsabilidade Civil Facultativa de Veículos (RCF-V ou terceiros).'
    },
    {
        CD_PRODUTO: 2940,
        NM_PRODUTO: "Ituran One 75",
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3,
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            }
        ],
        DS_TOOLTIP: 'O Ituran One garante a indenização em casos do veículo roubado/furtado que não haja a recuperação.'
    },
    {
        CD_PRODUTO: 2942,
        NM_PRODUTO: "Ituran One 90",
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3,
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            }
        ],
        DS_TOOLTIP: 'O Ituran One garante a indenização em casos do veículo roubado/furtado que não haja a recuperação.'
    },
    {
        CD_PRODUTO: 2944,
        NM_PRODUTO: "Ituran One Moto 75",
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3,
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            }
        ],
        DS_TOOLTIP: 'O Ituran One garante a indenização em casos do veículo roubado/furtado que não haja a recuperação.'
    },
    {
        CD_PRODUTO: 2946,
        NM_PRODUTO: "Ituran One Moto 90",
        NR_TIPO_PRODUTO: 12,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Cobertura Roubo, Furto, Incêndio',
                CD_PRODUTO_ADD: 3,
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 13
            }
        ],
        DS_TOOLTIP: 'O Ituran One garante a indenização em casos do veículo roubado/furtado que não haja a recuperação.'
    }
];

export const ProductsTracker = [
    {
        CD_PRODUTO: 1796,
        NM_PRODUTO: 'Rastreador Ituran Nacional',
        NR_TIPO_PRODUTO: 11,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Atuação Nacional',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Devolução da mensalidade em caso de não recuperação',
                CD_PRODUTO_ADD: 2
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 4
            }
        ]
    },
    {
        CD_PRODUTO: 2409,
        NM_PRODUTO: 'Rastreador Ituran Assist',
        NR_TIPO_PRODUTO: 11,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Atuação Nacional',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Devolução da mensalidade em caso de não recuperação',
                CD_PRODUTO_ADD: 2
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 4
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
                CD_PRODUTO_ADD: 5
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para a residência',
                CD_PRODUTO_ADD: 6
            }
        ]
    },
    {
        CD_PRODUTO: 2375,
        NM_PRODUTO: 'Rastreador Ituran Plus',
        NR_TIPO_PRODUTO: 11,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Atuação Nacional',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Devolução da mensalidade em caso de não recuperação',
                CD_PRODUTO_ADD: 2
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 4
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
                CD_PRODUTO_ADD: 5
            },
            {
                NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
                CD_PRODUTO_ADD: 7
            },
            {
                NM_PRODUTO_ADD: 'Seguro Acidentes Pessoais de Passageiros',
                CD_PRODUTO_ADD: 8
            },
            {
                NM_PRODUTO_ADD: 'Sorteio mensal: R$ 5.000',
                CD_PRODUTO_ADD: 9
            }
        ]
    },
    {
        CD_PRODUTO: 3459,
        NM_PRODUTO: 'Monitoramento GPRS EV + Garantia',
        NR_TIPO_PRODUTO: 11,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Atuação Nacional',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Devolução da mensalidade em caso de não recuperação',
                CD_PRODUTO_ADD: 2
            }
        ]
    },
    {
        CD_PRODUTO: 3460,
        NM_PRODUTO: 'Rastreador Ituran Assist EV',
        NR_TIPO_PRODUTO: 11,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Atuação Nacional',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Devolução da mensalidade em caso de não recuperação',
                CD_PRODUTO_ADD: 2
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 4
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
                CD_PRODUTO_ADD: 5
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para a residência',
                CD_PRODUTO_ADD: 6
            }
        ]
    },
    {
        CD_PRODUTO: 2430,
        NM_PRODUTO: 'Rastreador Ituran Moto',
        NR_TIPO_PRODUTO: 11,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Atuação Nacional',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Devolução da mensalidade em caso de não recuperação',
                CD_PRODUTO_ADD: 2
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 4
            },
        ]
    },
    {
        CD_PRODUTO: 2431,
        NM_PRODUTO: 'Rastreador Ituran Assist Moto',
        NR_TIPO_PRODUTO: 11,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 4
            },
            {
                NM_PRODUTO_ADD: 'Atuação Nacional',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Devolução da mensalidade em caso de não recuperação',
                CD_PRODUTO_ADD: 2
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
                CD_PRODUTO_ADD: 5
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para a residência',
                CD_PRODUTO_ADD: 6
            },
        ]
    },
    {
        CD_PRODUTO: 2596,
        NM_PRODUTO: 'Start Stop',
        NR_TIPO_PRODUTO: 11,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Chip BLOKI® para bloqueio do sinal da chave presencial',
                CD_PRODUTO_ADD: 2
            },
            {
                NM_PRODUTO_ADD: 'Atuação Nacional',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Devolução da mensalidade em caso de não recuperação',
                CD_PRODUTO_ADD: 4
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 5
            },
        ]
    },
    {
        CD_PRODUTO: 2600,
        NM_PRODUTO: 'Start Stop Assist',
        NR_TIPO_PRODUTO: 11,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Rastreador Ituran',
                CD_PRODUTO_ADD: 1
            },
            {
                NM_PRODUTO_ADD: 'Chip BLOKI® para bloqueio do sinal da chave presencial',
                CD_PRODUTO_ADD: 2
            },
            {
                NM_PRODUTO_ADD: 'Atuação Nacional',
                CD_PRODUTO_ADD: 3
            },
            {
                NM_PRODUTO_ADD: 'Devolução da mensalidade em caso de não recuperação',
                CD_PRODUTO_ADD: 4
            },
            {
                NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
                CD_PRODUTO_ADD: 5
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
                CD_PRODUTO_ADD: 6
            },
            {
                NM_PRODUTO_ADD: 'Assistência 24h para a residência',
                CD_PRODUTO_ADD: 7
            }
        ]
    },
];

export const ProductsAddServices = [
    {
        CD_PRODUTO: 2302,
        NM_PRODUTO: 'Reparo Rápido + Martelinho',
        NR_TIPO_PRODUTO: 13,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Reparos de lataria e pintura',
                CD_PRODUTO_ADD: 18
            }
        ]
    },
    {
        CD_PRODUTO: 2303,
        NM_PRODUTO: 'Proteção para Vidros',
        NR_TIPO_PRODUTO: 13,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Reparo de vidros básico',
                CD_PRODUTO_ADD: 19
            }
        ]
    },
    {
        CD_PRODUTO: 2304,
        NM_PRODUTO: 'Proteção para Faróis, Lanternas e Retrovisores',
        NR_TIPO_PRODUTO: 13,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Reparo de farol, lanterna e retrovisor',
                CD_PRODUTO_ADD: 20
            }
        ]
    },
    {
        CD_PRODUTO: 2380,
        NM_PRODUTO: 'Reparos - Pacote Essencial',
        NR_TIPO_PRODUTO: 13,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Reparos de lataria e pintura',
                CD_PRODUTO_ADD: 18
            },
            {
                NM_PRODUTO_ADD: 'Reparo de farol, lanterna e retrovisor',
                CD_PRODUTO_ADD: 20
            }
        ]
    },
    {
        CD_PRODUTO: 2381,
        NM_PRODUTO: 'Reparos - Pacote Exclusivo',
        NR_TIPO_PRODUTO: 13,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Reparos de lataria e pintura',
                CD_PRODUTO_ADD: 18
            },
            {
                NM_PRODUTO_ADD: 'Reparo de vidros básico',
                CD_PRODUTO_ADD: 19
            },
            {
                NM_PRODUTO_ADD: 'Reparo de farol, lanterna e retrovisor',
                CD_PRODUTO_ADD: 20
            }
        ]
    },
    {
        CD_PRODUTO: 2382,
        NM_PRODUTO: 'Reparos - Pacote Completo',
        NR_TIPO_PRODUTO: 13,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Reparos de lataria e pintura',
                CD_PRODUTO_ADD: 18
            },
            {
                NM_PRODUTO_ADD: 'Reparo de vidros básico',
                CD_PRODUTO_ADD: 19
            },
            {
                NM_PRODUTO_ADD: 'Reparo de farol, lanterna e retrovisor',
                CD_PRODUTO_ADD: 20
            },
            {
                NM_PRODUTO_ADD: 'Reparo de pneu, suspensão e roda',
                CD_PRODUTO_ADD: 21
            }
        ]
    },
];

export const ProductsSafe = [
    {
        CD_PRODUTO: 2424,
        NM_PRODUTO: 'Seguro Autopeças',
        NR_TIPO_PRODUTO: 15,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Cobertura R$ 3.000,00 para roubo de faróis, retrovisores, pneus, rodas, estepes, macaco e perda/roubo de chave do veículo.',
                CD_PRODUTO_ADD: 22
            }
        ]
    },
    {
        CD_PRODUTO: 2425,
        NM_PRODUTO: 'Seguro Conteúdo',
        NR_TIPO_PRODUTO: 15,
        DS_PRODUTO: [
            {
                NM_PRODUTO_ADD: 'Cobertura R$ 3.000,00 para roubo de celular, tablet, notebook e/ou óculos de sol.',
                CD_PRODUTO_ADD: 23
            }
        ]
    },
];

export const AdditionalServicesIcs = [
    {
        NM_PRODUTO_ADD: 'Rastreador Ituran',
        CD_PRODUTO_ADD: 1,
        DS_TOOLTIP_ADD: 'Esta indenização é o valor em percentual da FIPE que vc recebe se o seu veículo não for recuperado em caso de roubo ou furto e também se for recuperado com PT (destruído)!!!'
    },
    {
        NM_PRODUTO_ADD: 'Indenização tabela FIPE',
        CD_PRODUTO_ADD: 2,
        DS_TOOLTIP_ADD: 'Valor pago pela seguradora ao segurado/cliente, em referência ao valor do veículo na tabela FIPE, no momento do sinistro de eventos cobertos na apólice.'
    },
    {
        NM_PRODUTO_ADD: 'Cobertura de Roubo e Furto',
        CD_PRODUTO_ADD: 3,
    },
    {
        NM_PRODUTO_ADD: 'Cobertura de Incêndio',
        CD_PRODUTO_ADD: 3,
    },
    {
        NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
        CD_PRODUTO_ADD: 4,
        DS_TOOLTIP_ADD: 'Serviços disponíveis: guincho, pane eletromecânica, troca de pneus, chaveiro e transporte alternativo.'
    },
    {
        NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
        CD_PRODUTO_ADD: 6
    },
    {
        NM_PRODUTO_ADD: 'Cobertura Perda Total por Colisão',
        CD_PRODUTO_ADD: 9,
        DS_TOOLTIP_ADD: 'Proteção para seu veículo em caso de colisão que resulte em perda total (danos que superem 75% do valor FIPE).'
    },
    {
        NM_PRODUTO_ADD: 'Cobertura Perda Total por Alagamento',
        CD_PRODUTO_ADD: 10
    },
    {
        NM_PRODUTO_ADD: 'Cobertura de Perda Parcial (Franquia Normal)',
        CD_PRODUTO_ADD: 11,
        DS_TOOLTIP_ADD: `A cobertura de danos parciais poderá ser acionada, mediante pagamento de franquia,
                        nos casos de danos acidentais ao veículo segurado, decorrentes de colisão, 
                        roubo ou furto, incêndio, alagamento, entre outros eventos conforme Condições Gerais da apólice contratada.`
    },
    {
        NM_PRODUTO_ADD: 'Carro Reserva',
        CD_PRODUTO_ADD: 12,
        DS_TOOLTIP_ADD: `15 dias de Carro Reserva nos casos de sinistro coberto pela apólice (perda total por roubo, furto, incêndio, colisão e alagamento, e também nos casos de perda parcial.`
    },
    {
        NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
        CD_PRODUTO_ADD: 13
    },
    {
        NM_PRODUTO_ADD: 'Cobertura de Perda Parcial (Franquia Reduzida)',
        CD_PRODUTO_ADD: 14,
        DS_TOOLTIP_ADD: `A cobertura de danos parciais poderá ser acionada, mediante pagamento de franquia reduzida,
                        nos casos de danos acidentais ao veículo segurado, decorrentes de colisão, 
                        roubo ou furto, incêndio, alagamento, entre outros eventos conforme Condições Gerais da apólice contratada.`
    }
];

export const AdditionalServicesIcsEV = [
    {
        NM_PRODUTO_ADD: 'Rastreador Ituran',
        CD_PRODUTO_ADD: 1,
        DS_TOOLTIP_ADD: 'Esta indenização é o valor em percentual da FIPE que vc recebe se o seu veículo não for recuperado em caso de roubo ou furto e também se for recuperado com PT (destruído)!!!'
    },
    {
        NM_PRODUTO_ADD: 'Indenização tabela FIPE',
        CD_PRODUTO_ADD: 2,
        DS_TOOLTIP_ADD: 'Valor pago pela seguradora ao segurado/cliente, em referência ao valor do veículo na tabela FIPE, no momento do sinistro de eventos cobertos na apólice.'
    },
    {
        NM_PRODUTO_ADD: 'Carro Reserva',
        CD_PRODUTO_ADD: 12,
        DS_TOOLTIP_ADD: `15 dias de Carro Reserva nos casos de sinistro coberto pela apólice (perda total por roubo, furto, incêndio, colisão e alagamento, e também nos casos de perda parcial.`
    },
    // {
    //     NM_PRODUTO_ADD: 'Proteção para Vidros',
    //     CD_PRODUTO_ADD: 14
    // },
    {
        NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
        CD_PRODUTO_ADD: 4,
        DS_TOOLTIP_ADD: 'Serviços disponíveis: guincho, pane eletromecânica, troca de pneus, chaveiro e transporte alternativo.'
    },
    {
        NM_PRODUTO_ADD: 'Cobertura de Roubo e Furto',
        CD_PRODUTO_ADD: 3,
    },
    {
        NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
        CD_PRODUTO_ADD: 6
    },
    {
        NM_PRODUTO_ADD: 'Cobertura de Incêndio',
        CD_PRODUTO_ADD: 3,
    },
    {
        NM_PRODUTO_ADD: 'Cobertura Perda Total por Colisão',
        CD_PRODUTO_ADD: 9,
        DS_TOOLTIP_ADD: 'Proteção para seu veículo em caso de colisão que resulte em perda total (danos que superem 75% do valor FIPE).'
    },
    {
        NM_PRODUTO_ADD: 'Cobertura Perda Total por Alagamento',
        CD_PRODUTO_ADD: 10
    },
    {
        NM_PRODUTO_ADD: 'Cobertura de Perda Parcial (Franquia Normal)',
        CD_PRODUTO_ADD: 11,
        DS_TOOLTIP_ADD: `A cobertura de danos parciais poderá ser acionada, mediante pagamento de franquia,
                        nos casos de danos acidentais ao veículo segurado, decorrentes de colisão, 
                        roubo ou furto, incêndio, alagamento, entre outros eventos conforme Condições Gerais da apólice contratada.`
    },
    {
        NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
        CD_PRODUTO_ADD: 13
    },
];

export const AdditionalServicesIcsLight = [
    {
        NM_PRODUTO_ADD: 'Rastreador Ituran',
        CD_PRODUTO_ADD: 1,
    },
    {
        NM_PRODUTO_ADD: 'Indenização tabela FIPE',
        CD_PRODUTO_ADD: 2,
        DS_TOOLTIP_ADD: 'Valor pago pela seguradora ao segurado/cliente, em referência ao valor do veículo na tabela FIPE, no momento do sinistro de eventos cobertos na apólice.'
    },
    {
        NM_PRODUTO_ADD: 'Indenização por Roubo ou Furto',
        CD_PRODUTO_ADD: 3,
    },
    {
        NM_PRODUTO_ADD: 'Indenização por Incêndio',
        CD_PRODUTO_ADD: 15
    },
    {
        NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
        CD_PRODUTO_ADD: 6
    },
    {
        NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
        CD_PRODUTO_ADD: 13
    }
];

export const AdditionalServicesIcsMoto = [
    {
        NM_PRODUTO_ADD: 'Rastreador Ituran',
        CD_PRODUTO_ADD: 1,
        DS_TOOLTIP_ADD: 'Esta indenização é o valor em percentual da FIPE que vc recebe se o seu veículo não for recuperado em caso de roubo ou furto e também se for recuperado com PT (destruído)!!!'
    },
    {
        NM_PRODUTO_ADD: 'Indenização tabela FIPE',
        CD_PRODUTO_ADD: 2,
        DS_TOOLTIP_ADD: 'Valor pago pela seguradora ao segurado/cliente, em referência ao valor do veículo na tabela FIPE, no momento do sinistro de eventos cobertos na apólice.'
    },
    {
        NM_PRODUTO_ADD: 'Cobertura de Roubo e Furto',
        CD_PRODUTO_ADD: 3,
    },
    {
        NM_PRODUTO_ADD: 'Cobertura de Incêndio',
        CD_PRODUTO_ADD: 3,
    },
    {
        NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
        CD_PRODUTO_ADD: 4,
        DS_TOOLTIP_ADD: 'Serviços disponíveis: guincho, pane eletromecânica, troca de pneus, chaveiro e transporte alternativo.'
    },
    {
        NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
        CD_PRODUTO_ADD: 5
    },
    {
        NM_PRODUTO_ADD: 'Cobertura Perda Total por Colisão',
        CD_PRODUTO_ADD: 9,
        DS_TOOLTIP_ADD: 'Proteção para seu veículo em caso de colisão que resulte em perda total (danos que superem 75% do valor FIPE).'
    },
    {
        NM_PRODUTO_ADD: 'Cobertura Perda Total por Alagamento',
        CD_PRODUTO_ADD: 10
    },
    {
        NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
        CD_PRODUTO_ADD: 13
    },
    {
        NM_PRODUTO_ADD: 'Cobertura de Perda Parcial (Franquia Normal)',
        CD_PRODUTO_ADD: 11,
        DS_TOOLTIP_ADD: `A cobertura de danos parciais poderá ser acionada, mediante pagamento de franquia,
                        nos casos de danos acidentais ao veículo segurado decorrentes de colisão,
                        roubo ou furto, incêndio, alagamento, entre outros eventos, conforme Condições Gerais da apólice contratada.`
    }
];

export const AdditionalServicesTracker = [
    {
        NM_PRODUTO_ADD: 'Rastreador Ituran',
        CD_PRODUTO_ADD: 1,
    },
    {
        NM_PRODUTO_ADD: 'Devolução da mensalidade em caso de não recuperação',
        CD_PRODUTO_ADD: 2
    },
    {
        NM_PRODUTO_ADD: 'Atuação Nacional',
        CD_PRODUTO_ADD: 3
    },
    {
        NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
        CD_PRODUTO_ADD: 4
    },
    {
        NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
        CD_PRODUTO_ADD: 5,
        DS_TOOLTIP_ADD: 'Serviços disponíveis: guincho, pane eletromecânica, troca de pneus, chaveiro e transporte alternativo.'
    },
    {
        NM_PRODUTO_ADD: 'Assistência 24h para a residência',
        CD_PRODUTO_ADD: 6,
        DS_TOOLTIP_ADD: 'Serviços disponíveis: Chaveiro, Encanador e Eletricista.'
    },
    {
        NM_PRODUTO_ADD: 'Seguro RCF-V (para terceiros)',
        CD_PRODUTO_ADD: 7
    },
    {
        NM_PRODUTO_ADD: '<b style=font-weight:600;>Seguro Acidentes Pessoais de Passageiros</b> <br><i>R$ 10.000 por passageiro</i></br>',
        CD_PRODUTO_ADD: 8
    },
    {
        NM_PRODUTO_ADD: 'Sorteio mensal: R$ 5.000',
        CD_PRODUTO_ADD: 9
    },
    // {
    //     NM_PRODUTO_ADD: 'Chip BLOKI® para bloqueio do sinal da chave presencial',
    //     CD_PRODUTO_ADD: 13,
    //     DS_TOOLTIP_ADD: 'Exclusivo para veículos com partida por botão Start Stop.'
    // },
];

export const AdditionalServicesTrackerStartStop = [
    {
        NM_PRODUTO_ADD: 'Rastreador Ituran',
        CD_PRODUTO_ADD: 1,
        DS_TOOLTIP_ADD: 'Esta indenização é o valor em percentual da FIPE que vc recebe se o seu veículo não for recuperado em caso de roubo ou furto e também se for recuperado com PT (destruído)!!!'
    },
    {
        NM_PRODUTO_ADD: 'Chip BLOKI® para bloqueio do sinal da chave presencial',
        CD_PRODUTO_ADD: 2
    },
    {
        NM_PRODUTO_ADD: 'Atuação Nacional',
        CD_PRODUTO_ADD: 3
    },
    {
        NM_PRODUTO_ADD: 'Devolução da mensalidade em caso de não recuperação',
        CD_PRODUTO_ADD: 4
    },
    {
        NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
        CD_PRODUTO_ADD: 5
    },
    {
        NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
        CD_PRODUTO_ADD: 6
    },
    {
        NM_PRODUTO_ADD: 'Assistência 24h para a residência',
        CD_PRODUTO_ADD: 7
    }
];

export const AdditionalServicesTrackerMoto = [
    {
        NM_PRODUTO_ADD: 'Rastreador Ituran',
        CD_PRODUTO_ADD: 1,
        DS_TOOLTIP_ADD: 'Esta indenização é o valor em percentual da FIPE que vc recebe se o seu veículo não for recuperado em caso de roubo ou furto e também se for recuperado com PT (destruído)!!!'
    },
    {
        NM_PRODUTO_ADD: 'Devolução da mensalidade em caso de não recuperação',
        CD_PRODUTO_ADD: 2
    },
    {
        NM_PRODUTO_ADD: 'Atuação Nacional',
        CD_PRODUTO_ADD: 3
    },
    {
        NM_PRODUTO_ADD: 'Monitoramento via App Ituran Digital',
        CD_PRODUTO_ADD: 4
    },
    {
        NM_PRODUTO_ADD: 'Assistência 24h para o veículo',
        CD_PRODUTO_ADD: 5,
        DS_TOOLTIP_ADD: 'Serviços disponíveis: guincho, pane eletromecânica, troca de pneus, chaveiro e transporte alternativo.'
    },
    {
        NM_PRODUTO_ADD: 'Assistência 24h para a residência',
        CD_PRODUTO_ADD: 6,
        DS_TOOLTIP_ADD: 'Serviços disponíveis: Chaveiro, Encanador e Eletricista.'
    }
];

export const AdditionalServices = [
    {
        NM_PRODUTO: 'Assist auto + Resid',
        DS_TITULO_SITE: 'Assistência Emergencial Básica - Automóvel',
        CD_PRODUTO: 2580,
        NM_TITULO: `Precisou de assistência 24h nós temos a solução! <b>Não fique sem esta cobertura.</b>`,
        DS_PRODUTO: [
            {
                DS_COBERTURA: [
                    `Assistência 24h para o <b>veículo:</b>
                <br/>
                <br/>
                <ul>
                    <li>
                        Guincho limitado a 100km
                    </li>
                    <li>
                        Carga de bateria
                    </li>
                    <li>
                        Auxílio Mecânico / Elétrico',
                    </li>
                    <li>
                        Pane seca
                    </li>
                    <li>
                        Chaveiro
                    </li>
                    <li>
                        Troca de pneu
                    </li>
                </ul>
                `,
                ],
            },
            {
                DS_COBERTURA: [
                    `Assistência 24h para <b>residência:</b>
                <br/>
                <br/>
                <ul>
                    <li>
                        Chaveiro
                    </li>
                    <li>
                        Encanador
                    </li>
                    <li>
                        Eletricista
                    </li>
                    <li>
                        03 acionamentos dentro da vigência de 12 meses.
                    </li>
                </ul>
                `,
                ]
            }
        ]
    },
    {
        NM_PRODUTO: 'Assist moto + Resid',
        DS_TITULO_SITE: 'Assistência Emergencial Básica - Moto',
        CD_PRODUTO: 2581,
        NM_TITULO: `Precisou de assistência 24h nós temos a solução! <b>Não fique sem esta cobertura.</b>`,
        DS_PRODUTO: [
            {
                DS_COBERTURA: [
                    `Assistência 24h para o <b>moto:</b>
                <br/>
                <br/>
                <ul>
                    <li>
                        Guincho limitado a 100km
                    </li>
                    <li>
                        Carga de bateria
                    </li>
                    <li>
                        Pane seca
                    </li>
                    <li>
                        Chaveiro
                    </li>
                </ul>
                `,
                ],
            },
            {
                DS_COBERTURA: [
                    `Assistência 24h para <b>residência:</b>
                        <br/>
                        <br/>
                        <ul>
                            <li>
                                Chaveiro
                            </li>
                            <li>
                                Encanador
                            </li>
                            <li>
                                Eletricista
                            </li>
                            <li>
                                03 acionamentos dentro da vigência de 12 meses.
                            </li>
                        </ul>
                        `,
                ]
            }
        ]
    },
    {
        NM_PRODUTO: 'Carro reserva',
        DS_TITULO_SITE: 'Assistência Carro Reserva',
        CD_PRODUTO: 2420,
        NM_TITULO: `Não fique sem carro/moto. Esse serviço te proporciona um carro reserva por 15 dias consecutivos em caso de roubo/furto ou PT. <br/>
        O Carro Reserva é um serviço adicional para clientes que adquirirem qualquer produto Ituran, seja da família ICS ou da família Monitoramento.`,
        DS_PRODUTO: [
            {
                DS_COBERTURA: [
                    'Ter um condutor maior de 21 anos;',
                    'O condutor deverá ser habilitado há pelo menos 2 anos;',
                    `Possuir um cartão de crédito, a ser usado como caução, com limite disponível <br/>
                    de no mínimo R$ 1.000,00 e, ter ciência de que, dependendo da locadora <br/>
                    disponível para a retirada do veículo, poderá ser solicitado um valor superior de <br/>
                    limite no cartão de crédito`
                ],
            },
        ],
    },
    {
        NM_PRODUTO: 'Seguro Conteúdo',
        DS_TITULO_SITE: 'Seguro Conteúdo',
        CD_PRODUTO: 2425,
        NM_TITULO: `Fique seguro em casos de roubo e/ou furto qualificado de objetos que estiverem
        dentro do seu veículo.<br/>
        Esta cobertura garante indenização de até R$ 3.000,00 para: celular, tablet, notebook e/ou óculos de sol.`,
        DS_PRODUTO: [
            {
                DS_COBERTURA: [
                    `<b>Vigência: 12 MESES</b>`,
                    `<b>Franquia: Não há</b>`,
                    `<b>Carência: 30 DIAS</b>`
                ],
            },
        ],
    },
    {
        NM_PRODUTO: 'Seguro Autopeças',
        DS_TITULO_SITE: 'Seguro Auto Peças',
        CD_PRODUTO: 2424,
        NM_TITULO: `Cobertura para todo o território nacional que garante a indenização em casos de roubo <br/>
        e/ou furto qualificado das seguintes peças do veículo: faróis, espelhos retrovisores, <br/>
        pneus, rodas, estepes e/ou macaco e ainda, cobertura para perda ou roubo das <br/>
        chaves do veículo. Limite máximo de indenização: R$ 3.000,00.`,
        DS_PRODUTO: [
            {
                DS_COBERTURA: [
                    '<b>Vigência: 12 MESES</b>',
                    '<b>Franquia: Não há</b>',
                    '<b>Carência: 30 DIAS</b>'
                ],
            },
        ],
    },
    {
        NM_PRODUTO: 'Reparos + martelinho',
        DS_TITULO_SITE: 'Assistência de Lataria e Pintura + Martelinho',
        CD_PRODUTO: 2574,
        NM_TITULO: `Garante o reparo de danos acidentais causados ao veículo, sejam eles arranhões, <br/>
        amassados e danos à pintura, para-choques e peças plásticas externas.`,
        DS_PRODUTO: [
            {
                DS_COBERTURA: [
                    '<b>Veículo não pode ter danos pré-existentes</b>',
                    '<b>1 acionamento de reparo com valor máximo de mão de obra de até R$ 1000,00 + 4 acionamentos de martelinho</b>',
                    '<b>Reparo com pintura - R$ 185,00</b>',
                    '<b>Martelinho reparação sem pintura - R$ 80,00</b>',
                    '<b>Martelinho Teto - R$ 300,00</b>',
                ]
            },
        ],
    },
    {
        NM_PRODUTO: 'Proteção para Faróis, Lanternas e Retrovisores',
        DS_TITULO_SITE: 'Proteção de Faróis, Lanternas e Retrovisores',
        CD_PRODUTO: 2304,
        NM_TITULO: `Ocorrendo a quebra ou a trinca dos retrovisores, faróis, lanternas dianteiras ou
        traseiras do veículo para o qual a proteção esteja contratada, esta cobertura garantirá
        em caso de acidente o reparo ou, caso este não seja viável, a substituição da peça. A
        troca será feita pelo mesmo tipo e modelo da peça integrante ao modelo original de
        fábrica do veículo, homologadas e com certificação do Inmetro, e que atendam as
        especificações técnicas do fabricante, não sendo estas necessariamente da mesma
        marca da peça anterior.`,
        DS_PRODUTO: [
            {
                DS_COBERTURA: [
                    '<b>Veículo não pode ter danos pré-existentes</b>',
                    '<b>2 acionamentos para faróis e lanternas + 2 acionamentos para retrovisores</b>',
                    '<b>Farol convencional ou Auxiliar - R$ 275,00</b>',
                    '<b>Farol (convencional ou Auxiliar) LED/Xenon - R$ 1.310,00</b>',
                    '<b>Lanterna Convencional - R$ 165,00</b>',
                    '<b>Lanterna com LED - R$ 405,00</b>',
                    '<b>Retrovisor Convencional - R$ 160,00</b>',
                    '<b>Retrovisor com LED - R$ 305,00</b>'
                ],
            },
        ]
    },
    {
        NM_PRODUTO: 'Proteção para Vidros',
        DS_TITULO_SITE: 'Proteção para Vidros',
        CD_PRODUTO: 2303,
        NM_TITULO: `Nos casos de quebra ou trinca do vidro do para-brisa, do vidro traseiro ou dos vidros
        laterais do veículo, em razão de acidentes ocorridos exclusivamente com o vidro,
        exceto o Roubo/Furto ou incêndio do próprio vidro, esta assistência quando contratada
        e vigente, garantirá o reparo ou, caso este não seja viável, a substituição do vidro. A
        troca será feita pelo mesmo tipo e modelo da peça integrante do veículo fabricado.`,
        DS_PRODUTO: [
            {
                DS_COBERTURA: [
                    '<b>Veículo não pode ter danos pré-existentes</b>',
                    '<b>2 acionamentos ao ano e 01 acionamento para Máquina de Vidros, a cada 12 meses.</b>',
                    '<b>Para-brisa - R$ 315,00</b>',
                    '<b>Vigia - R$ 275,00</b>',
                    '<b>Lateral - R$ 145,00</b>',
                    '<b>Máquina de vidro - R$ 105,00</b>'
                ],
            },
        ]
    },
    {
        NM_PRODUTO: 'Lataria + FLR + Buracos Moto',
        DS_TITULO_SITE: 'Reparos Gerais + Proteção de Rodas e Pneus',
        CD_PRODUTO: 2575,
        NM_TITULO: `O serviço compreende a reparação e pintura de funilaria + reparo rápido e martelinho
        de ouro para peças plásticas e para-lama que possam ser danificados em pequenas colisões. 
        Substituição de faróis, lanternas e retrovisores, sejam eles de led ou convencionais.`,
        DS_PRODUTO: [
            {
                DS_COBERTURA: [
                    '<b>Veículo não pode ter danos pré-existentes</b>',
                    `<b>Garante a troca ou reparo dos pneus, rodas (de ferro ou liga leve) e suspensão <br />
            (amortecedor, mola, bucha e retentor) nos casos de danos provenientes de <br />
            queda em buracos ou pancadas em guias. </br> Garantia de 01 ano nos serviços 
            prestados.</b>`,
                    `
                    <div id="table" style='margin-top: 1rem;'>
                      <table>
                        <thead>
                          <tr>
                            <th>Categoria</th>
                            <th>Farol</th>
                            <th>Lanterna</th>
                            <th>Retrovisor</th>
                            <th>Farol Xenon/led</th>
                          </tr>
                        </thead>     
                        <tbody>
                          <tr>
                            <td>101 a 450 CC</td>
                            <td>R$ 105,00</td>
                            <td>R$ 105,00</td>
                            <td>R$ 35,00</td>
                            <td>R$ 350,00</td>
                          </tr>
                          <tr>
                            <td>451 CC ou mais</td>
                            <td>R$ 375,00</td>
                            <td>R$ 325,00</td>
                            <td>R$ 185,00</td>
                            <td>R$ 1.280,00</td>
                          </tr>
                        </tbody>
                      </table>
                      <table style='margin-top: .5rem;'>
                        <thead>
                          <tr>
                            <th>Categoria</th>
                            <th>Lanterna Led</th>
                            <th>Farol Aux.</th>
                            <th>Lanterna Aux.</th>
                            <th>Lataria e Pintura.</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td>101 a 450 CC</td>
                            <td>R$ 140,00</td>
                            <td>R$ 115,00</td>
                            <td>R$ 95,00</td>
                            <td>R$ 95,00</td>
                          </tr>
                          <tr>
                            <td>451 CC ou mais</td>
                            <td>R$ 360,00</td>
                            <td>R$ 265,00</td>
                            <td>R$ 220,00</td>
                            <td>R$ 95,00</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  `,
                ]
            },
            {
                DS_COBERTURA: [
                    '<b>Pagamento da coparticipação de maior valor, caso seja necessária a troca de mais de um item;</b>',
                    `<b>Carência de 01 mês para acionamento;</br> 01 acionamento a cada 12 meses; </br>
                    Inclui retirada por guincho do local do acidente, caso necessário, dentro de um raio
                    de 100 Km.</b>`,
                ]
            }
        ]
    },
    {
        NM_PRODUTO: 'Reparos de Lataria, Faróis, Lanternas e Retrovisores',
        DS_TITULO_SITE: 'Reparos de Lataria, Faróis, Lanternas e Retrovisores',
        CD_PRODUTO: 2452,
        NM_TITULO: `Cobertura para reparo e pintura de lataria, peças plásticas e para-choque que foram
        danificados em pequenas colisões.
        </br>
        </br>
        1 acionamento de reparo com valor máximo de mão de obra de até R$ 600,00. Caso
        o cliente opte por levar a moto em uma oficina não referenciada o limite máximo de
        utilização será de até R$ 380,00 na vigência. 
        </br>
        Coparticipação - Valor fixo por acionamento.
        </br>
        Categoria Reparação de lataria e pintura A partir de 101 cilindradas R$ 90,00
        `,
        DS_PRODUTO: [
            {
                DS_COBERTURA: []
            }
        ]
    },
    {
        NM_PRODUTO: 'Proteção para Buracos',
        DS_TITULO_SITE: 'Proteção para Buracos',
        CD_PRODUTO: 2453,
        NM_TITULO: `É uma cobertura para proteção de roda, pneus e suspensão contra danos gerados
        por impactos acidentais em objetos cortantes e/ou contundentes, tais como guias,
        blocos de sinalização de pista, buracos, desníveis acentuados de pontes, pedras,
        vidros etc. Os danos considerados são:
        <br/>
        <ul>
            <li>
                Pneu - troca em caso de ruptura, rasgo ou deformação da parede lateral do pneu;
            </li>
            <li>
                Roda - troca em caso de trincas ou quebras no aro ou disco da roda;
            </li>
            <li>
                Suspensão - amortecedores, molas, braço oscilante, pivô e barra estabilizadora.
            </li>
        </ul>
        `,
        DS_PRODUTO: [
            {
                DS_COBERTURA: [
                    '<b>Veículo não pode ter danos pré-existentes</b>',
                    '<b>1 acionamento ao ano</b>',
                    '<b>Pneu - R$ 185,00</b>',
                    '<b>Roda Ferro - R$ 185,00</b>',
                    '<b>Roda Liga-Leve - R$ 185,00</b>',
                    '<b>Suspensão - R$ 185,00</b>',
                ]
            },
        ]
    },
    {
        NM_PRODUTO: 'Lataria + FLR',
        DS_TITULO_SITE: 'Reparos - Pacote Essencial',
        CD_PRODUTO: 2380,
        NM_TITULO: `Serviços adicionais completo para proteger ainda mais seu carro, não fique sem esta
        cobertura.
        <br/>
        <ul>
            <li>
                <b>Assistência de Lataria e Pintura</b>
            </li>
            <li>
                <b>Martelinho</b>
            </li>
            <li>
                <b>Proteção para Faróis, Lanternas e Retrovisores</b>
            </li>
        </ul>
        `,
        DS_PRODUTO: [
            {
                DS_COBERTURA: [
                    `<b>Veículo não pode ter danos pré-existentes</b><br/>`,
                    `<b>Para Assistência de Lataria e Pintura + Martelinho</b>
                        <br/>
                        <br/>
                        <ul>
                            <li>
                                1 acionamento de reparo com valor máximo de mão de obra de até R$ 1000,00 +
                                4 acionamentos de martelinho
                            </li>
                            <li>
                                Reparo com pintura - R$ 185,00
                            </li>
                            <li>
                                Martelinho reparação sem pintura - R$ 80,00
                            </li>
                            <li>
                                Martelinho Teto - R$ 300,00
                            </li>
                        </ul>
                        `,
                ]
            },
            {
                DS_COBERTURA: [
                    `<br/><br/><b>Para Proteção de Faróis, Lanternas e Retrovisores</b>
                        <br/>
                        <br/>
                        <ul>
                            <li>
                                2 acionamentos para faróis e lanternas + 2 acionamentos para retrovisores
                            </li>
                            <li>
                                Farol convencional ou Auxiliar - R$ 275,00
                            </li>
                            <li>
                                Farol (convencional ou Auxiliar) LED/Xenon - R$ 1.310,00
                            </li>
                            <li>
                                Lanterna Convencional - R$ 165,00
                            </li>
                            <li>
                                Lanterna com LED - R$ 405,00
                            </li>
                            <li>
                                Retrovisor Convencional - R$ 160,00
                            </li>
                            <li>
                                Retrovisor com LED - R$ 305,00
                            </li>
                        </ul>
                        `,
                ]
            },
        ]
    },
    {
        NM_PRODUTO: 'Lataria + FLR + Vidros',
        DS_TITULO_SITE: 'Reparos - Pacote Exclusivo',
        CD_PRODUTO: 2381,
        NM_TITULO: `Serviços adicionais completo para proteger ainda mais seu carro, não fique sem esta
        cobertura.
        <br/>
        <ul>
            <li>
                <b>Assistência de Lataria e Pintura</b>
            </li>
            <li>
                <b>Martelinho</b>
            </li>
            <li>
                <b>Proteção para Faróis, Lanternas e Retrovisores</b>
            </li>
            <li>
                <b>Proteção para Vidros</b>
            </li>
        </ul>
        `,
        DS_PRODUTO: [
            {
                DS_COBERTURA: [
                    `<b>Veículo não pode ter danos pré-existentes</b><br/>`,
                    `<b>Para Assistência de Lataria e Pintura + Martelinho</b>
                        <br/>
                        <br/>
                        <ul>
                            <li>
                                1 acionamento de reparo com valor máximo de mão de obra de até R$ 1000,00 +
                                4 acionamentos de martelinho
                            </li>
                            <li>
                                Reparo com pintura - R$ 185,00
                            </li>
                            <li>
                                Martelinho reparação sem pintura - R$ 80,00
                            </li>
                            <li>
                                Martelinho Teto - R$ 300,00
                            </li>
                        </ul>
                        `,
                ]
            },
            {
                DS_COBERTURA: [
                    `<br/><br/><b>Para Proteção de Faróis, Lanternas e Retrovisores</b>
                        <br/>
                        <br/>
                        <ul>
                            <li>
                                2 acionamentos para faróis e lanternas + 2 acionamentos para retrovisores
                            </li>
                            <li>
                                Farol convencional ou Auxiliar - R$ 275,00
                            </li>
                            <li>
                                Farol (convencional ou Auxiliar) LED/Xenon - R$ 1.310,00
                            </li>
                            <li>
                                Lanterna Convencional - R$ 165,00
                            </li>
                            <li>
                                Lanterna com LED - R$ 405,00
                            </li>
                            <li>
                                Retrovisor Convencional - R$ 160,00
                            </li>
                            <li>
                                Retrovisor com LED - R$ 305,00
                            </li>
                        </ul>
                        `,
                ]
            },
            {
                DS_COBERTURA: [
                    `<br/><br/><b>Para Proteção para Vidros</b>
                        <br/>
                        <br/>
                        <ul>
                            <li>
                                2 acionamentos ao ano e 01 acionamento para Máquina de Vidros, a cada 12 meses.
                            </li>
                            <li>
                                Para-brisa - R$ 315,00
                            </li>
                            <li>
                                Vigia - R$ 275,00
                            </li>
                            <li>
                                Lateral - R$ 145,00
                            </li>
                            <li>
                            Máquina de vidro - R$ 105,00
                            </li>
                        </ul>
                        `,
                ]
            },
        ]
    },
    {
        NM_PRODUTO: 'Lataria + FLR + Vidros + Buracos',
        DS_TITULO_SITE: 'Reparos - Pacote Completo',
        CD_PRODUTO: 2382,
        NM_TITULO: `Serviços adicionais completo para proteger ainda mais seu carro, não fique sem esta
        cobertura.
        <br/>
        <ul>
            <li>
                <b>Assistência de Lataria e Pintura</b>
            </li>
            <li>
                <b>Martelinho</b>
            </li>
            <li>
                <b>Proteção para Faróis, Lanternas e Retrovisores</b>
            </li>
            <li>
                <b>Proteção para Vidros</b>
            </li>
            <li>
                <b>Proteção para Buracos</b>
            </li>
        </ul>
        `,
        DS_PRODUTO: [
            {
                DS_COBERTURA: [
                    `<b>Veículo não pode ter danos pré-existentes</b><br/>`,
                    `<b>Para Assistência de Lataria e Pintura + Martelinho</b>
                        <br/>
                        <br/>
                        <ul>
                            <li>
                                1 acionamento de reparo com valor máximo de mão de obra de até R$ 1000,00 +
                                4 acionamentos de martelinho
                            </li>
                            <li>
                                Reparo com pintura - R$ 185,00
                            </li>
                            <li>
                                Martelinho reparação sem pintura - R$ 80,00
                            </li>
                            <li>
                                Martelinho Teto - R$ 300,00
                            </li>
                        </ul>
                        `,
                ]
            },
            {
                DS_COBERTURA: [
                    `<br/><br/><b>Para Proteção de Faróis, Lanternas e Retrovisores</b>
                        <br/>
                        <br/>
                        <ul>
                            <li>
                                2 acionamentos para faróis e lanternas + 2 acionamentos para retrovisores
                            </li>
                            <li>
                                Farol convencional ou Auxiliar - R$ 275,00
                            </li>
                            <li>
                                Farol (convencional ou Auxiliar) LED/Xenon - R$ 1.310,00
                            </li>
                            <li>
                                Lanterna Convencional - R$ 165,00
                            </li>
                            <li>
                                Lanterna com LED - R$ 405,00
                            </li>
                            <li>
                                Retrovisor Convencional - R$ 160,00
                            </li>
                            <li>
                                Retrovisor com LED - R$ 305,00
                            </li>
                        </ul>
                        `,
                ]
            },
            {
                DS_COBERTURA: [
                    `<b>Para Proteção para Vidros</b>
                        <br/>
                        <br/>
                        <ul>
                            <li>
                                2 acionamentos ao ano e 01 acionamento para Máquina de Vidros, a cada 12 meses.
                            </li>
                            <li>
                                Para-brisa - R$ 315,00
                            </li>
                            <li>
                                Vigia - R$ 275,00
                            </li>
                            <li>
                                Lateral - R$ 145,00
                            </li>
                            <li>
                            Máquina de vidro - R$ 105,00
                            </li>
                        </ul>
                        `,
                ]
            },
            {
                DS_COBERTURA: [
                    `<b>Para Proteção para Buracos</b>
                        <br/>
                        <br/>
                        <ul>
                            <li>
                                1 acionamento ao ano
                            </li>
                            <li>
                                Pneu - R$ 185,00
                            </li>
                            <li>
                                Roda Ferro - R$ 185,00
                            </li>
                            <li>
                                Roda Liga-Leve - R$ 185,00
                            </li>
                            <li>
                                Suspensão - R$ 180,00
                            </li>
                        </ul>
                        `,
                ]
            },
        ]
    },
];